import script from "./SearchApp.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchApp.vue?vue&type=script&setup=true&lang=ts"

import "./SearchApp.vue?vue&type=style&index=0&id=7eea9fbe&lang=css"

const __exports__ = script;

export default __exports__